import { render, staticRenderFns } from "./ListTicketArsip.vue?vue&type=template&id=83982008"
import script from "./ListTicketArsip.vue?vue&type=script&lang=js"
export * from "./ListTicketArsip.vue?vue&type=script&lang=js"
import style0 from "./ListTicketArsip.vue?vue&type=style&index=0&id=83982008&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports